Information to identify the person,
including their name and methods of communicating with the person.
